'use strict';

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../../sections/template-account');

require('../../../styles/templates/customers/account.scss');

require('../../../styles/templates/customers/addresses.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _themeSections.load)(['template-account']);

var $newAddressForm = (0, _jquery2.default)('#AddressNewForm');

if ($newAddressForm.length) {
  // Toggle new/edit address forms
  (0, _jquery2.default)('.address-new-toggle').on('click', function () {
    $newAddressForm.toggleClass('hide');
    (0, _jquery2.default)('[data-address]').toggleClass('hide');
  });

  (0, _jquery2.default)('.address-edit-toggle').on('click', function () {
    var formId = (0, _jquery2.default)(this).data('form-id');
    (0, _jquery2.default)('#EditAddress_' + formId).toggleClass('hide');
    (0, _jquery2.default)('[data-address]').toggleClass('hide');
  });

  (0, _jquery2.default)('.address-delete').on('click', function (event) {
    var $el = (0, _jquery2.default)(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    event.preventDefault();

    if (window.confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {
        parameters: { _method: 'delete' }
      });
    }
  });
}